'use es6';

import http from 'hub-http/clients/apiClient';
import { BASE_URI_PROGRESS } from '../constants/ApiConstants';
export const ACHIEVEMENTS = `${BASE_URI_PROGRESS}/achievements`;
export const fetchAchievementsAll = () => http.get(ACHIEVEMENTS);